import { Divider, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import {
    Control,
    FieldErrors,
    UseFormRegister,
    UseFormReset,
    UseFormSetValue,
} from "react-hook-form";
import { shallowEqual, useSelector } from "react-redux";
import WSButton from "../../../Components/Button/WSButton";
import WSHiddenField from "../../../Components/HiddenField/WSHiddenField";
import WSTextField, { CurrencyType, TextType } from "../../../Components/TextBox/WSTextBox";
import { AppState } from "../../../StateManagement/types";
import WSSelectField from "../../../Components/Select/WSSelect";
import WSTextAreaField from "../../../Components/WSTextArea/WSTextArea";
interface PaymentVoucherProps {
    control?: Control<any>;
    errors?: FieldErrors;
    register: UseFormRegister<any>;
    id: any;
    reset: UseFormReset<any>;
    voucherId?: string;
    setValue: UseFormSetValue<any>;
    onCancel: () => void
    data?: any
}

const PaymentVoucherDrawyer: React.FC<PaymentVoucherProps> = ({
    control, errors, register, id, reset, setValue, data, onCancel, voucherId
}) => {

    useEffect(() => {
        return () => {
            reset();
        };
    }, []);
    
    useEffect(() => {
        if (data) {
            setValue('recieptNumber', data?.recieptNumber)
            setValue('voucherNumber', data?.voucherNumber)
            setValue('amountReceived', data?.amountReceived)
            setValue('unitPrice', data?.unitPrice)
            setValue('paymentMethod', data?.paymentMethod)
            setValue('transactionReference', data?.transactionReference)
            setValue('narration', data?.narration)
            setValue('notes', data?.notes)
        }
    }, [data, setValue, voucherId])
    const reduxComponentData = useSelector(
        (state: AppState) => state.components["voucherSubmit"],
        shallowEqual
    );

    // Local state to store Redux data
    const [componentData, setComponentData] = useState(reduxComponentData);

    // Update useState when Redux state changes
    useEffect(() => {
        if (reduxComponentData) {
            setComponentData(reduxComponentData);
        }
    }, [reduxComponentData]);
    return (
        <Grid >
            {<Grid container spacing={2} mt={2}>

                <Grid item xs={12}>
                    <Typography fontWeight={"bold"}>Payment Voucher Information</Typography>
                </Grid>
                {/* <Grid item xs={12} sm={12}>
                    <WSTextField
                        label={"Reciept Number"}
                        id="recieptNumber"
                        name="recieptNumber"
                        control={control}
                        rules={{ required: true }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <WSTextField
                        label={"Voucher Number"}
                        id="voucherNumber"
                        name="voucherNumber"
                        control={control}
                        rules={{ required: true }}
                    />
                </Grid> */}
                <Grid item xs={12} sm={6}>
                    <WSTextField
                        label={"Amount Received"}
                        id="amountReceived"
                        name="amountReceived"
                        control={control}
                        rules={{ required: true }}
                        type={TextType.Currency}
                        currency={CurrencyType.Rupee}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <WSSelectField
                        label={"PaymentMethod"}
                        id="paymentMethod"
                        name="paymentMethod"
                        control={control}
                        rules={{ required: true }}
                        options={[{ label: 'Cash', value: 'Cash' }, { label: 'Card', value: 'Card' }, { label: 'Gpay', value: 'Gpay' }]}

                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <WSTextField
                        label={"Transaction Reference"}
                        id="transactionReference"
                        name="transactionReference"
                        control={control}
                        rules={{ required: false }}
                    />
                    <WSHiddenField control={control} name="voucherId" defaultValue={voucherId} />
                </Grid>
                {/* <Grid item xs={12}>
                    <WSTextAreaField
                        label="Narration"
                        id="narration"
                        setValue={setValue}
                        control={control}
                        rules={{ required: true }}
                        name="narration"
                        rows={1}
                    />
                </Grid> */}
                <Grid item xs={12}>
                    <WSTextAreaField
                        label="Notes"
                        id="notes"
                        setValue={setValue}
                        control={control}
                        rules={{ required: false }}
                        name="notes"
                        rows={1}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <Divider />
                </Grid>

                <Grid item container spacing={2} style={{ paddingTop: '1rem' }} justifyContent={'end'}>
                    <Grid item sx={{ marginRight: 0 }}>
                        <WSButton className="ws-theme-crm" variant="outlined" id='voucherSubmit' label={"Save"} type="submit" size="medium" loading={reduxComponentData?.data?.loading} />
                    </Grid>
                    <Grid item sx={{ marginRight: 0 }}>
                        <WSButton id='cancel' label={"Cancel"} onClick={onCancel} type="button" size="medium" variant="outlined" className="ws-theme-crm" />
                    </Grid>
                </Grid>
            </Grid>
            }
        </Grid>
    );
};
export default PaymentVoucherDrawyer;
